const getCookie = (name) => {
  const matches = document.cookie && document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\\.$?*|{}\\(\\)\\[\]\\\\/\\+^])/g, "\\$1")}=([^;]*)`,
  ));

  return matches ? decodeURIComponent(matches[1]) : null;
};

export default getCookie;
